export const defaultMemberPasswordResetCreateFormData = {
    username: '',
    email: '',
    captcha: undefined
};
